import React, { useEffect, useState } from "react";
import { api } from "@/api";
import { useSettings } from "@/contexts/SettingsContext";
import { useTranslation } from "react-i18next";
import { Save, Check } from "lucide-react";

const LANGS = ["fr", "en", "de", "zh-CN"];

export default function AdminSettings() {
  const { t } = useTranslation();
  const { settings: ctx, refresh } = useSettings();
  const [s, setS] = useState(null);
  const [saved, setSaved] = useState(false);

  useEffect(() => { if (ctx) setS({ ...ctx }); }, [ctx]);

  if (!s) return <div className="p-12 text-[#F8F5EF]/60">…</div>;

  const set = (k, v) => setS({ ...s, [k]: v });
  const setI = (k, lang, v) => setS({ ...s, [k]: { ...(s[k] || {}), [lang]: v } });

  const save = async () => {
    await api.put("/settings", s);
    setSaved(true);
    refresh();
    setTimeout(() => setSaved(false), 2000);
  };

  return (
    <div className="p-8 lg:p-12" data-testid="admin-settings-page">
      <div className="overline">Back-office</div>
      <h1 className="font-serif-luxe text-4xl text-[#F8F5EF] mt-2 mb-8">{t("admin.settings")}</h1>

      <div className="luxe-card p-8 space-y-6 max-w-3xl">
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
          <div><label className="overline mb-2 block">Téléphone fixe</label><input value={s.phone || ""} onChange={e => set("phone", e.target.value)} className="input-luxe" data-testid="set-phone" /></div>
          <div><label className="overline mb-2 block">WhatsApp (affiché)</label><input value={s.whatsapp || ""} onChange={e => set("whatsapp", e.target.value)} className="input-luxe" data-testid="set-whatsapp" /></div>
          <div><label className="overline mb-2 block">WhatsApp brut (lien wa.me)</label><input value={s.whatsapp_raw || ""} onChange={e => set("whatsapp_raw", e.target.value)} className="input-luxe" /></div>
          <div><label className="overline mb-2 block">Email</label><input value={s.email || ""} onChange={e => set("email", e.target.value)} className="input-luxe" /></div>
          <div className="sm:col-span-2"><label className="overline mb-2 block">Adresse</label><input value={s.address || ""} onChange={e => set("address", e.target.value)} className="input-luxe" /></div>
          <div><label className="overline mb-2 block">Lien Google Maps</label><input value={s.maps_url || ""} onChange={e => set("maps_url", e.target.value)} className="input-luxe" /></div>
          <div><label className="overline mb-2 block">URL embed Google Maps</label><input value={s.maps_embed || ""} onChange={e => set("maps_embed", e.target.value)} className="input-luxe" /></div>
          <div><label className="overline mb-2 block">Instagram</label><input value={s.instagram_url || ""} onChange={e => set("instagram_url", e.target.value)} className="input-luxe" /></div>
          <div><label className="overline mb-2 block">Facebook</label><input value={s.facebook_url || ""} onChange={e => set("facebook_url", e.target.value)} className="input-luxe" /></div>
        </div>

        <div>
          <label className="overline mb-2 block">Horaires (par langue)</label>
          <div className="space-y-2">
            {LANGS.map(l => (
              <div key={l} className="flex gap-2 items-start">
                <span className="text-[10px] tracking-[0.2em] uppercase text-[#D4AF37] w-12 pt-3">{l}</span>
                <textarea rows={2} value={s.hours?.[l] || ""} onChange={e => setI("hours", l, e.target.value)} className="input-luxe flex-1" />
              </div>
            ))}
          </div>
        </div>

        <div className="border-t border-[#D4AF37]/15 pt-6">
          <div className="overline mb-3">Mentions légales</div>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <div><label className="overline mb-2 block">Société</label><input value={s.legal_company || ""} onChange={e => set("legal_company", e.target.value)} className="input-luxe" /></div>
            <div><label className="overline mb-2 block">SIRET</label><input value={s.legal_siret || ""} onChange={e => set("legal_siret", e.target.value)} className="input-luxe" /></div>
            <div><label className="overline mb-2 block">Directeur publication</label><input value={s.legal_director || ""} onChange={e => set("legal_director", e.target.value)} className="input-luxe" /></div>
            <div><label className="overline mb-2 block">Hébergeur</label><input value={s.legal_host || ""} onChange={e => set("legal_host", e.target.value)} className="input-luxe" /></div>
          </div>
        </div>

        <button onClick={save} className="btn-gold" data-testid="admin-save-settings"><Save size={14} /> Enregistrer</button>
        {saved && <div data-testid="admin-saved-confirm" className="flex items-center gap-2 text-emerald-400 text-sm"><Check size={16} /> Enregistré</div>}
      </div>
    </div>
  );
}
